import { useIsAuthenticated } from "react-auth-kit";
import { Redirect } from "react-router-dom";

/**
 * A Higher-Order Component (HOC) that redirects authenticated users to the dashboard.
 * Used to wrap public routes like Sign In or Sign Up so that logged-in users 
 * cannot access them and are immediately sent back to their dashboard.
 * 
 * @param {React.ComponentType} Component - The component to wrap.
 * @returns {React.FC} A new component that handles the redirection logic.
 */
const WithDashboardRedirect = Component => {
    return function Comp(props) {
        const isAuthenticated = useIsAuthenticated()
        const isLoggedIn = isAuthenticated()
        return isLoggedIn
            ? <Redirect to={'/dashboard'}/>
            : <Component {...props}/>
    }
}

export default WithDashboardRedirect